import {Form, Select} from 'antd';
import React from 'react';
import {AdmissionMethod} from '../../containers/HealthcareUsageReport/types/CohortQuery';

const { Option } = Select

const FIELD_NAME = "admissionMethod"
const FIELD_LABEL = "Admission Method"

interface Props {
    isDisabled: boolean
}

const AdmissionMethodSelector = ({ isDisabled }: Props) => {
    return <Form.Item name={FIELD_NAME} label={FIELD_LABEL} rules={[]}>
        <Select
            style={{ width: '100%' }}
            placeholder={FIELD_LABEL}
            filterOption={true}
            disabled={isDisabled}
        >
            <Option value={AdmissionMethod.ALL}>All</Option>
            <Option value={AdmissionMethod.ELECTIVE}>Elective</Option>
            <Option value={AdmissionMethod.NON_ELECTIVE}>Non Elective</Option>
        </Select>
    </Form.Item >
}

export default AdmissionMethodSelector